<template>
  <div class="ren-decoration-cp ren-decoration-cp-interaction-bar">
    <span v-for="item in actions" :key="item">{{ item }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const actions = computed(() => {
  const items: string[] = []
  if (booleanValue(props.component.props?.showLike, true)) items.push('点赞')
  if (booleanValue(props.component.props?.showComment, true)) items.push('评论')
  if (booleanValue(props.component.props?.showFavorite, true)) items.push('收藏')
  if (booleanValue(props.component.props?.showShare, true)) items.push('分享')
  return items
})
</script>
